module.exports = __webpack_public_path__ + "img/37340-023.328a9448.jpg";